const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailyReportsIconOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.26 49.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6,31.38H29.29v4.49H13.6Zm0-9H36V26.9H13.6Zm0-9H36v4.48H13.6Zm26.9-9H31.13a6.7,6.7,0,0,0-12.65,0H9.11a4.33,4.33,0,0,0-.89.09A4.5,4.5,0,0,0,6,5.81,4.39,4.39,0,0,0,5,7.24,4.25,4.25,0,0,0,4.63,9V40.35A4.49,4.49,0,0,0,5,42.1a4.61,4.61,0,0,0,1,1.43,4.5,4.5,0,0,0,2.27,1.24,6.44,6.44,0,0,0,.89.06H40.5A4.49,4.49,0,0,0,45,40.35V9A4.5,4.5,0,0,0,40.5,4.48ZM24.8,3.92A1.69,1.69,0,1,1,23.12,5.6,1.71,1.71,0,0,1,24.8,3.92ZM40.5,40.35H9.11V9H40.5Z",
    style: {
      fill: "#fff",
      opacity: 0.800000011920929
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyReportsIconOutlined);
export default __webpack_public_path__ + "static/media/daily_reports_icon_outlined.79a082fe859b74e11af581360803e264.svg";
export { ForwardRef as ReactComponent };